import 'promise-polyfill/src/polyfill';
import objectFitImages from 'object-fit-images';
import objectFitVideos from 'object-fit-videos';
import freeform from "./freeform";
import header from "./header";
import lightbox from "./lightbox";
import swiper from "./swiper";
import mapbox from "./mapbox";
// import your components here

objectFitImages();
objectFitVideos();
freeform();
header();
swiper();
mapbox();
lightbox();
// use your imported components here
// SampleButton();